<template>
	<app-page>
		<app-heading :title="isNew ? 'New Profile' : profile.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button
						type="cancel"
						small
						:to="{ name: 'integration-child', params: {
							integration: integrationId,
							tab: 'profiles',
						}}"
					>Cancel</app-button>
				</app-section-actions>
				<input-text
					type="text"
					label="Name"
					v-model="profile.name"
					:errors="errors.name"
					required
				/>
				<input-text
					type="text"
					label="Slug"
					v-model="profile.slug"
					:errors="errors.slug"
					required
				/>
				<div v-for="(data, field) in integration.auth" :key="`auth-${field}`">
					<input-combobox v-if="data.multiple"
						:label="data.name"
						v-model="profile.auth[field]"
						:errors="errors.name"
						multiple
						can-add
						no-selection
					/>
					<input-text v-else
						:type="data.encrypted ? 'password' : 'text'"
						:label="data.name"
						v-model="profile.auth[field]"
						:errors="errors.name"
						required
					/>
				</div>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
import { reduce } from 'lodash'

const ENCRYPTED_SYMBOL = '__3NC__'

export default {
	async created() {
		try {
			this.$store.dispatch('app/startLoading')

			// Get integration
			const integration = await this.$ravello.request()
				.v(2)
				.to('integrations')
				.to(this.integrationId)
				.get()

			integration.auth = reduce(integration.auth, (acc, data, field) => (data.profile ? {
				...acc, [field]: data,
			} : acc), {})
			this.integration = integration
			// Update authentication object
			this.profile.auth = reduce(this.integration.auth, (acc, data, field) => {
				acc[field] = ''
				return acc
			}, {})

			if (this.id !== 'new') {
				const profile = await this.$ravello.request()
					.v(2)
					.to('integrations')
					.to(this.integrationId)
					.to('profiles')
					.to(this.id)
					.get()

				this.profile = {
					name: profile.name,
					slug: profile.slug,
					auth: reduce(profile.auth, (acc, value, field) => {
						if (this.integration.auth[field]) {
							if (this.integration.auth[field].multiple) {
								acc[field] = value.split(',')
							} else {
								acc[field] = this.integration.auth[field].encrypted ? ENCRYPTED_SYMBOL : value
							}
						}
						return acc
					}, {}),
				}
			}

			this.$store.dispatch('app/stopLoading')
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
	},
	data() {
		return {
			integration: {},
			profile: {
				name: '',
				slug: '',
				auth: {},
			},
			errors: {},
		}
	},
	computed: {
		integrationId() {
			return this.$route.params.integration
		},
		id() {
			return this.$route.params.profile
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		getProfileAuthData() {
			return {
				...this.profile,
				auth: reduce(this.profile.auth, (acc, value, field) => {
					if (value !== ENCRYPTED_SYMBOL) {
						acc[field] = value
					}
					if (Array.isArray(value)) {
						acc[field] = value.join(',')
					}
					return acc
				}, {}),
			}
		},

		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('integrations')
						.to(this.integrationId)
						.to('profiles')
						.create(this.getProfileAuthData())
				} else {
					await this.$ravello.request().to('integrations')
						.v(2)
						.to(this.integrationId)
						.to('profiles')
						.to(this.id)
						.update(this.getProfileAuthData())
				}
				this.$store.dispatch('app/stopLoading')
				this.$router.push({
					name: 'integration-child',
					params: {
						integration: this.integrationId,
						tab: 'profiles',
					},
				})
				this.$notifications.pushAlert('success', `Profile successfully ${this.isNew ? 'added' : 'updated'}`)
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}

				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
